const data = {
  counterText: 'Plazas limitadas disponibles',
  loading: 'Cargando',
  next: 'Siguiente',
  previous: 'Previo',
  smCounterText: 'Espacio disponible limitado.',
};

export default data;
